<h3>
  INFORMATIVA IN MATERIA DI PROTEZIONE DEI DATI PERSONALI
  AI SENSI DEGLI ARTT. 13 E 14 DEL REGOLAMENTO (UE) 2016/679 (GDPR)
</h3>
<ol>
  <li>
    <h4>
      Titolarità del trattamento e finalità del trattamento
    </h4>
    <p>
      Il Titolare del trattamento dei dati raccolti è INVITALIA, in persona del legale rappresentante pro
      tempore.
      IlData Protection Officer (“DPO”), quale Responsabile della protezione dei dati di INVITALIA, può
      essere contattato via mail all’indirizzo: <a href="mailto:rpd@invitalia.it">RPD&#64;invitalia.it</a>, unicamente
      per
      l’esercizio dei diritti degli
      interessati di cui agli articoli dal 15 al 21 del GDPR.
    </p>
    <p>
      INVITALIA, quando opera, a seguito di conferimento di incarico, di convenzione/contratto, con gli
      Enti Aderenti ovvero con le Amministrazioni Aggiudicatrici che intendono avvalersi dei servizi
      erogati mediante la “Piattaforma”, potrà assumere il ruolo di Contitolare del trattamento ai sensi
      dell’art. 26 “Contitolari del trattamento” del “GDPR” ovvero potrà assumere il ruolo di Responsabile
      del trattamento.
    </p>
    <p>
      I dati personali saranno trattati per le finalità connesse alla selezione degli Operatori Economici da
      invitare alle procedure per l’acquisizione di lavori, beni e servizi, per le procedure di scelta del
      contraente, per la partecipazione ai bandi di gara.
    </p>

  </li>
  <li>
    <h4>
      Categoria dati, modalità e durata del trattamento, base giuridica del trattamento
    </h4>
    <p>
      I dati personali trattati sono i dati anagrafici, amministrativi, economici e giudiziari di Fornitori, di
      Operatori economici e familiari conviventi, dei componenti delle Commissioni di gara, quali a titolo
      esemplificativo: Nome, Cognome, indirizzo, mail, numero telefono, ragionesociale, bilanci, eventuali
      garanzie, casellari giudiziali.
    </p>
    <p>
      I dati personali forniti sono trattati con strumenti automatizzati per la durata prevista all’art. 112
      comma 4 del Codice dei Contratti (D.Lgs.36/2023): le Stazioni appaltanti devono garantire la
      conservazione della documentazione sufficiente a giustificare decisioni adottate in tutte le fasi della
      procedura di appalto; la documentazione è conservata per almeno 5 anni a partire dalla data di
      aggiudicazione dell’appalto, ovvero in caso di pendenza di una controversia, fino al passaggio in
      giudicato della relativa sentenza. Tempistiche più ampie potrebbero essere necessarie in caso di
      rendicontazioni agli Enti preposti/richiedenti.
    </p>
    <p>
      I dati personali vengono trattati, ai fini della corretta esecuzione delle procedure di gara, ai sensi degli
      articoli 28, 35 e 36 del D.Lgs. 36/2023 ed il trattamento trova la sua base giuridica nell’art. 6 comma
      1, lettere b), c) ed e) del GDPR.
    </p>
    <p>
      Per le finalità di rendicontazione e di esecuzione di un ordine di esibizione, la base giuridica è
      l’esecuzione di un obbligo normativo.
    </p>
  </li>
  <li>
    <h4>
      Ambito di circolazione dei dati
    </h4>
    <p>
      A tali dati avranno accesso solo il personale diINVITALIA, come incaricato del trattamento, oppure
      incaricati del trattamento di aziende che svolgono servizi strumentali di manutenzione della
      piattaforma per conto di INVITALIA nonché incaricati del trattamento appartenenti a Bravo Solution
      Italia S.p.A., a Bravo Solution S.p.A. e Step S.r.l., che agiscono in qualità di Responsabili del
      trattamento per le attività di gestione tecnica della medesima piattaforma, ai sensi e per gli effetti
      dell’art. 28 del GDPR.
    </p>
    <p>
      I trattamenti dei dati hanno luogo presso la sede del Titolare e dell’eventuale Contitolare e presso la
      sede del Responsabile del trattamento, ognuno per le rispettive competenze, e sono curati solo da
      personale incaricato del trattamento oppure da eventuali soggetti incaricati di fornire servizi
      strumentali alla manutenzione della Piattaforma.
    </p>
    <p>
      I dati non saranno oggetto di diffusione al di fuori dello svolgimento delle attività strumentali a
      perseguire le predette finalità. Essi, pertanto, potranno essere comunicati ad enti pubblici, nonché a
      soggetti terzi in Italia e all’estero, competenti rispetto alle suddette finalità. I dati saranno, altresì,
      oggetto
      di diffusione, comunque, nei limiti e modalità di cui agli articoli 35 e 36 del D.Lgs. 36/2023 e ss.mm.ii,
      con manleva di Invitalia per eventuali danni derivati a terzi i cui dati personali l'Utente abbia reso noti
      su propria esclusiva iniziativa. Per le finalità di “Trasparenza dei Contratti Pubblici” di cui all’articolo
      28 del D.Lgs. 36/2023, i dati potranno essere trasmessi alla Banca dati Nazionale dei Contratti pubblici.
    </p>
    <p>
      I dati potranno essere comunicati ai fini di rendicontazione al Sistema Regis del MEF e ad altri Enti,
      Istituzioni, Autorità, anche in forza di un ordine di esibizione.
    </p>
  </li>
  <li>
    <h4>
      Volontarietà
    </h4>
    <p>
      Il conferimento dei dati è necessario per consentire l’accesso alla piattaforma e in
      difetto non sarà possibile avvalersi di tale piattaforma, in tutto o in parte.
    </p>
  </li>
  <li>
    <h4>
      Dati di navigazione
    </h4>
    <p>
      I sistemi informatici e le procedure software preposte al funzionamento di questa piattaforma
      telematica acquisiscono, nel corso del loro normale esercizio, alcune informazioni tecniche (esempio
      log e indirizzi IP), incluse ai fini di adempienza ai requisiti di Legge in termini di tracciabilità,
      sicurezza ed intangibilità delle operazioni effettuate in Piattaforma.
    </p>
    <p>
      Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che
      per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con altri dati, permettere di
      identificare gli utenti.
    </p>
    <p>
      In questa categoria di datirientrano gli indirizzi IP.
    </p>
    <p>
      Questi dati vengono utilizzati alsolo fine di assicurare il corretto funzionamento della piattaforma.
    </p>
  </li>
  <li>
    <h4>
      Esercizio dei diritti
    </h4>
    <p>
      L’interessato potrà esercitare, con modalità compatibili alle norme speciali in materia di contratti
      pubblici, i seguenti diritti previsti dal GDPR:
    </p>
    <ul>
      <li>
        diritto di revocare il consenso ai sensi dell’articolo 7 del GDPR, senza pregiudicare la liceità del
        trattamento basata sul consenso prestato prima della revoca o basata sulle altre condizioni di cui
        all’articolo 6 del GDPR;
      </li>
      <li>
        diritto di proporre reclamo al Garante per la protezione dei dati personali ai sensi dell’articolo
        77 del GDPR;
      </li>
      <li>
        diritto di accesso ai sensi dell’articolo 15 del GDPR;
      </li>
      <li>
        diritto di rettifica ai sensi dell’articolo 16 del GDPR;
      </li>
      <li>
        diritto alla cancellazione aisensi e nei limiti dell’articolo 17 del GDPR;
      </li>
      <li>
        diritto di limitazione di trattamento aisensi e nei limiti dell’articolo 18 del GDPR;
      </li>
      <li>
        diritto alla portabilità dei dati aisensi e nei limiti dell’articolo 20 del GDPR;
      </li>
      <li>
        diritto di opposizione aisensi e nei limiti dell’articolo 21 del GDPR.
      </li>
    </ul>
    <p>
      A tal fine, l’interessato potrà rivolgersi direttamente al Titolare, all’indirizzo: <a
        href="mailto:rpd@invitalia.it">RPD&#64;invitalia.it</a>,
      unicamente compilando il <a target="_blank" href="https://forms.office.com/r/0pSs3F1Na7">Form</a> esercizio dei
      diritti in materia di protezione dei dati personali.
    </p>
  </li>
</ol>
